// Renders children via createPortal(document.body) so overlays, dialogs, and menus
// are never clipped by ancestor overflow or stacking contexts.

import { createPortal } from 'react-dom';
import type { JSX, ReactNode } from 'react';

import type { PortaledLayerProps } from './types/SharedProps';

export type { PortaledLayerProps };

export function PortaledLayer({ children }: PortaledLayerProps): JSX.Element {
  return createPortal(children, document.body);
}
